import { Button, Input, InputError, Select, Textarea } from '@foodsby/nutrient'
import React, { useState } from 'react'
import { states } from 'us'

import { Submitting } from '../common/Submitting'

const STATES = Object.keys(states).map(state => ({
  label: state,
  value: state,
}))

const SubmitBuildingForm = ({ city, error, invalid, onSubmit, state, street, submitting, zip }) => {
  const [formState, setFormState] = useState({
    city: city || '',
    country_code: 'US',
    debug: '1',
    debugEmail: 'buildings@foodsby.com',
    description: '',
    email: '',
    first_name: '',
    last_name: '',
    lead_source: 'Foodsby Website',
    oid: process.env.REACT_APP_SALESFORCE_OID,
    phone: '',
    recordType: '012f4000000YP7O',
    state_code: state || '',
    street: street || '',
    zip: zip || '',
  })
  const handleChange = e => setFormState({ ...formState, [e.target.name]: e.target.value })

  const handleSubmit = e => {
    e.preventDefault()
    onSubmit(formState)
  }
  return (
    <form onSubmit={handleSubmit}>
      <div className="row start-xs">
        <div className="col-xs-12">
          <Input
            id="street"
            label="Address *"
            name="street"
            onChange={handleChange}
            required
            type="text"
            value={formState.street}
          />
        </div>
      </div>
      <div className="row start-xs">
        <div className="col-xs-12 col-md-4">
          <Input
            id="city"
            label="City *"
            name="city"
            onChange={handleChange}
            required
            type="text"
            value={formState.city}
          />
        </div>
        <div className="col-xs-12 col-md-4">
          <label htmlFor="state">State *</label>
          <Select
            defaultValue={STATES.find(s => s.value === state)}
            id="state"
            name="state_code"
            onChange={e => setFormState({ ...formState, state_code: e.value })}
            options={STATES}
            required
            type="select"
            value={STATES.find(s => s.value === formState.state_code)}
          />
        </div>
        <div className="col-xs-12 col-md-4">
          <Input
            id="zip"
            label="Zip Code *"
            name="zip"
            onChange={handleChange}
            required
            type="text"
            value={formState.zip}
          />
        </div>
      </div>
      <div className="row start-xs">
        <div className="col-xs-12 col-md-6">
          <Input
            id="first_name"
            label="First Name *"
            name="first_name"
            onChange={handleChange}
            required
            type="text"
            value={formState.first_name}
          />
        </div>
        <div className="col-xs-12 col-md-6">
          <Input
            id="last_name"
            label="Last Name *"
            name="last_name"
            onChange={handleChange}
            required
            type="text"
            value={formState.last_name}
          />
        </div>
      </div>
      <div className="row start-xs">
        <div className="col-xs-12 col-md-6">
          <Input
            id="email"
            label="Email *"
            name="email"
            onChange={handleChange}
            required
            type="email"
            value={formState.email}
          />
        </div>
        <div className="col-xs-12 col-md-6">
          <Input
            format="(###) ###-####"
            id="phone"
            label="Phone"
            mask="_"
            name="phone"
            onChange={handleChange}
            placeholder="(___) ___-____"
            type="tel"
            value={formState.phone}
          />
        </div>
      </div>
      <div className="row start-xs">
        <div className="col-xs">
          <Textarea
            id="description"
            label="Comments"
            name="description"
            onChange={handleChange}
            type="textarea"
            value={formState.description}
          />
        </div>
      </div>
      {submitting ? (
        <Submitting />
      ) : (
        <Button className={invalid ? 'disabled' : 'primary'} id="submit" type="submit">
          Submit
        </Button>
      )}
      <InputError>{error}</InputError>
    </form>
  )
}

export default SubmitBuildingForm
